import React, { useState } from 'react';
import Context, { contextDefaultValue } from 'context';
import { Activity, ContextType } from 'type';

type Props = {
  children: React.ReactElement;
};

const ContextProvider = ({ children }: Props) => {
  const [mainText, setMainText] = useState(contextDefaultValue.mainText);
  const [suppText, setSuppText] = useState(contextDefaultValue.suppText);
  const [caption, setCaption] = useState(contextDefaultValue.caption);
  const [timeline, setTimeline] = useState(contextDefaultValue.timeline);
  const [gender, setGender] = useState<ContextType['gender']>(
    contextDefaultValue.gender
  );
  const [profile, setProfile] = useState<string>();
  const [colors, setColors] = useState<ContextType['colors']>(
    contextDefaultValue.colors
  );

  const ACTIVITY: Activity = {
    time: '',
    place: '*คลิกเพื่อแก้ไขข้อความ',
  };

  const setDate = (date: string, index: number) => {
    const tmp = [...timeline];
    tmp[index].date = date;
    setTimeline(tmp);
  };

  const setTime = (time: string, dateIndex: number, activityIndex: number) => {
    const tmp = [...timeline];
    tmp[dateIndex].activities[activityIndex].time = time;
    setTimeline(tmp);
  };

  const setPlace = (
    place: string,
    dateIndex: number,
    activityIndex: number
  ) => {
    const tmp = [...timeline];
    tmp[dateIndex].activities[activityIndex].place = place;
    setTimeline(tmp);
  };

  const addDate = (dateIndex?: number) => {
    if (timeline.length === 7) return;
    const newTimeline = {
      date: '1 ม.ค. 64',
      activities: [ACTIVITY],
    };
    if (!!!dateIndex) {
      setTimeline([...timeline, newTimeline]);
    } else {
      setTimeline([
        ...timeline.slice(0, dateIndex + 1),
        newTimeline,
        ...timeline.slice(dateIndex + 1, timeline.length),
      ]);
    }
  };

  const removeDate = () => {
    if (timeline.length > 1) {
      setTimeline(timeline.slice(0, timeline.length - 1));
    }
  };

  const addActivity = (dateIndex: number, activityIndex: number) => {
    const timelineTmp = [...timeline];
    const newTimelineActivity = [
      ...timelineTmp[dateIndex].activities.slice(0, activityIndex + 1),
      ACTIVITY,
      ...timelineTmp[dateIndex].activities.slice(
        activityIndex + 1,
        timelineTmp[dateIndex].activities.length
      ),
    ];
    timelineTmp[dateIndex].activities = newTimelineActivity;
    setTimeline(timelineTmp);
  };

  const value = {
    mainText,
    setMainText,
    suppText,
    setSuppText,
    timeline,
    setTimeline,
    caption,
    setCaption,
    setDate,
    setTime,
    setPlace,
    addDate,
    removeDate,
    addActivity,
    gender,
    setGender,
    profile,
    setProfile,
    colors,
    setColors,
  };
  return <Context.Provider value={value}>{children}</Context.Provider>;
};

export default ContextProvider;
